import { render } from "./TicketHistory.vue?vue&type=template&id=1a6901a6&scoped=true"
import script from "./TicketHistory.vue?vue&type=script&lang=js"
export * from "./TicketHistory.vue?vue&type=script&lang=js"

import "./TicketHistory.vue?vue&type=style&index=0&id=1a6901a6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a6901a6"],['__file',"src/components/history/TicketHistory.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1a6901a6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1a6901a6', __exports__)) {
    api.reload('1a6901a6', __exports__)
  }
  
  module.hot.accept("./TicketHistory.vue?vue&type=template&id=1a6901a6&scoped=true", () => {
    api.rerender('1a6901a6', render)
  })

}


export default __exports__